import PropTypes from 'prop-types';

const { Component } = React;

export default class ReactLoader extends Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: ''
  };

  _renderSkChildren = () => {
    const items = [];

    for(let i = 0; i <= 11; i++) {
      items.push(<div key={i} className={`sk-circle${i} sk-child`} />);
    }

    return items;
  };

  render() {
    const items = this._renderSkChildren();

    return (
      <div className={`sk-circle ${this.props.className}`}>
        {items}
      </div>
    );
  }
}
